import { Grid, MultiSelect } from '@mantine/core';
import FormHeading from 'apps/Projects/SamplePlans/FormInputs/FormHeading';

import { METER_STR, THIRTY_CM_STR } from 'constants/projects';

import InputAndLabelGridRow from 'common/Components/InputAndLabelGridRow';

import { useProjectsTranslations } from '../hooks';
import { useSamplePlanFormContext } from '../samplePlanFormContextV2';

import { useCarbonPlanConfigQuery } from './queries';

const DepthQuantifyDetails = () => {
  const translations = useProjectsTranslations();
  const samplePlanForm = useSamplePlanFormContext();
  const formValues = samplePlanForm.getValues();

  const { samplePlanConfig } = useCarbonPlanConfigQuery();

  const updateDepthQuantify = (values: string[]) => {
    samplePlanForm.setValues({
      isMeterCore: values.includes(METER_STR),
      isThirtyCmCore: values.includes(THIRTY_CM_STR),
    });
  };
  const getSelectedDepths = () => {
    const selectedDepths: string[] = [];
    if (formValues.isMeterCore) {
      selectedDepths.push(METER_STR);
    }
    if (formValues.isThirtyCmCore) {
      selectedDepths.push(THIRTY_CM_STR);
    }
    return selectedDepths;
  };

  return (
    <>
      <FormHeading text={translations.depthQuantifyQuestion} mb="xs" />
      <Grid>
        <InputAndLabelGridRow
          elemId="depth-quantify"
          label={translations.depth}
          span={5}
          input={
            <MultiSelect
              data={samplePlanConfig?.depths}
              id="depth-quantify-select"
              value={getSelectedDepths()}
              onChange={updateDepthQuantify}
            />
          }
        />
      </Grid>
    </>
  );
};

export default DepthQuantifyDetails;
